import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { AdminService } from "../../../services/admin.service";
import {
  faEllipsisVertical,
  faMagnifyingGlass,
  faPlus,
  faPenToSquare,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";
import CustomToggle from "../../../Components/toggle";
import EditSubject from "../../../Components/Modal/EditSubject.modal";
import AddSubject from "../../../Components/Modal/AddSubject.modal";
import { useNavigate } from "react-router-dom";
import { StringHelper } from "../../../helper/string.helper";
import UpdateSubjectModal from "../../../Components/Modal/UpdateSubject.modal";
import TablePagination from "../../../Components/Pagination/Table.paginaition";

export default function SubjectIndex() {

    const navigate = useNavigate();

    const [subjects, setSubjects] = useState<any>();
    const [editSubject, setEditSubject] = useState<any>(undefined);
    const [addSubjectShow, setAddSubjectShow] = useState<boolean>(false);
    const [subjectIndex, setSubjectIndex] = useState<any>(undefined);

    const [searchText, setSearchText] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);

    const getAllSubjects = async () => {
        await AdminService.getAllSubjects(searchText, currentPage, perPage).then((res) => {
            if (res.status == 200) {
                setSubjects(res.data.subjects)
                setTotalCount(res.data.totalSubjects)
            }
        }).catch((err) => {
            console.log(err);

        })
    }

    useEffect(() => {
        getAllSubjects();
    }, [editSubject, addSubjectShow, searchText, currentPage, perPage])


    return (
        <>
            <EditSubject
                subjectId={editSubject}
                setShow={() => setEditSubject(undefined)}
            />

            <AddSubject
                show={addSubjectShow}
                setShow={setAddSubjectShow}
            />
            <div className="ds-page-head">
                <div className="d-flex align-items-center">
                    <h1 className="ds-page-title">Subjects</h1>
                    <span className="ds-count-pill">{subjects?.length || "0"}</span>
                </div>
                <div className="ds-search-wrap">
                    <FontAwesomeIcon icon={faMagnifyingGlass} className="ds-search-icon" />
                    <input
                        type="text"
                        className="ds-search"
                        placeholder="Search subjects..."
                        onChange={(e: any) => setSearchText(e.target.value)}
                    />
                </div>
            </div>

            <div className="ds-toolbar">
                <span className="ds-section-label">All Subjects</span>
                <button
                    className="ds-btn ds-btn-primary ds-btn-sm"
                    onClick={() => setAddSubjectShow(true)}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    Add Subject
                </button>
            </div>

            <div className="d-flex flex-column gap-2 mt-3">
                {subjects && subjects.length > 0 && subjects.map((data: any, index: number) => {
                    return (
                        <div
                            className="ds-card ds-card-hover ds-card-pad ds-subject-row"
                            key={data._id || index}
                        >
                            <div className="ds-subject-main">
                                <span className="ds-avatar ds-avatar--neutral">
                                    {index + 1}
                                </span>
                                <div style={{ minWidth: 0 }}>
                                    <div className="ds-cell-strong mb-1">{data.name}</div>
                                    <div className="ds-chip-row">
                                        {data.topics && data.topics.length > 0 ? (
                                            <>
                                                {data.topics.slice(0, 8).map((topic: any, i: number) => (
                                                    <span className="ds-chip" key={i}>
                                                        {StringHelper.Truncate(topic.name, 18)}
                                                    </span>
                                                ))}
                                                {data.topics.length > 8 && (
                                                    <span className="ds-chip ds-chip--more">
                                                        +{data.topics.length - 8} more
                                                    </span>
                                                )}
                                            </>
                                        ) : (
                                            <span className="ds-cell-muted xcn-text-12">
                                                No topics added
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <Dropdown align="end">
                                <Dropdown.Toggle
                                    as={CustomToggle}
                                    id="dropxdown-custom-components"
                                >
                                    <span className="ds-icon-btn">
                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                    </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setSubjectIndex(index)}>
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            navigate("/superAdmin/subject/" + data._id)
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faListUl} />
                                        Add Topics
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    )
                })}
            </div>

            <div className="text-center mt-3">
                <TablePagination
                    total={totalCount}
                    currentPage={currentPage}
                    perPage={perPage}
                    handlePageChange={(e: number) => {
                        setCurrentPage(e)
                    }}
                    setPerPage={(e: number) => { setPerPage(e) }}
                />

            </div>

            <UpdateSubjectModal
                show={subjectIndex >= 0 ? true : false}
                handleClose={() => {
                    setSubjectIndex(undefined)
                    getAllSubjects();
                }}
                data={subjects && subjects[subjectIndex]}
            />
        </>
    )
}